var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "card mt-2 shadow-sm"
  }, [_c('div', {
    staticClass: "\n        card-header\n        border-0\n        d-flex\n        justify-content-between\n        align-items-center\n      ",
    on: {
      "click": function click($event) {
        _vm.visibleDetail = !_vm.visibleDetail;
      }
    }
  }, [_vm._v(" 結帳明細 "), _c('i', {
    staticClass: "fa",
    class: "fa-chevron-".concat(_vm.visibleDetail ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('b-collapse', {
    staticClass: "products",
    model: {
      value: _vm.visibleDetail,
      callback: function callback($$v) {
        _vm.visibleDetail = $$v;
      },
      expression: "visibleDetail"
    }
  }, [_vm._l(_vm.products, function (p) {
    return _c('div', {
      key: p.name,
      staticClass: "products__item p-3"
    }, [_c('div', {
      staticClass: "products__item__photo product__photo"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": "https://picsum.photos/200?".concat(Math.random())
      }
    })]), _c('div', {
      staticClass: "\n            products__item__title\n            product__title\n            d-inline-block\n            text-truncate\n          "
    }, [_vm._v(" " + _vm._s(p.title) + " ")]), _c('div', {
      staticClass: "\n            products__item__price\n            d-flex\n            justify-content-between\n            align-items-center\n          "
    }, [_c('div', [p.oprice ? _c('span', {
      staticClass: "oprice mr-1"
    }, [_vm._v(_vm._s(p.oprice))]) : _vm._e(), _c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(p.price))])]), _c('div', {
      staticClass: "small"
    }, [_vm._v("x1")])])]);
  }), _c('div', {
    staticClass: "p-3 detail"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('span', [_vm._v("訂單金額")]), _c('span', {
    staticClass: "text-dark"
  }, [_vm._v("$ 4,160")])]), _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('span', [_vm._v("運費")]), _c('span', {
    staticClass: "text-primary"
  }, [_vm._v("免運費")])])]), _c('div', {
    staticClass: "d-flex justify-content-between card-header border-0"
  }, [_c('span', [_vm._v("總金額")]), _c('span', {
    staticClass: "price"
  }, [_vm._v("NT$ 3,560")])])], 2)], 1), _c('div', {
    staticClass: "card mt-2 shadow-sm"
  }, [_c('div', {
    staticClass: "\n        card-header\n        border-0\n        d-flex\n        justify-content-between\n        align-items-center\n      ",
    on: {
      "click": function click($event) {
        _vm.visiblePurchaser = !_vm.visiblePurchaser;
      }
    }
  }, [_vm._v(" 訂購人資訊 "), _c('i', {
    staticClass: "fa",
    class: "fa-chevron-".concat(_vm.visiblePurchaser ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('b-collapse', {
    model: {
      value: _vm.visiblePurchaser,
      callback: function callback($$v) {
        _vm.visiblePurchaser = $$v;
      },
      expression: "visiblePurchaser"
    }
  }, [_c('div', {
    staticClass: "p-3 detail"
  }, [_c('div', [_vm._v("黃*彬")]), _c('div', [_vm._v("新北市永和區永和路一段***號*樓")]), _c('div', [_vm._v("0911***450")])])])], 1), _c('div', {
    staticClass: "card mt-2 shadow-sm"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between align-items-center"
  }, [_vm._v(" 收件人資訊 ")]), _c('div', {
    staticClass: "p-3"
  }, [_c('b-form-group', [_c('b-form-radio', {
    staticClass: "py-2 font-weight-bold",
    attrs: {
      "value": "1"
    },
    model: {
      value: _vm.recipientType,
      callback: function callback($$v) {
        _vm.recipientType = $$v;
      },
      expression: "recipientType"
    }
  }, [_vm._v("同訂購人")]), _c('b-form-radio', {
    staticClass: "py-2",
    attrs: {
      "value": "2"
    },
    model: {
      value: _vm.recipientType,
      callback: function callback($$v) {
        _vm.recipientType = $$v;
      },
      expression: "recipientType"
    }
  }, [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("填寫收件人資料")]), _c('div', {
    staticClass: "py-3 row"
  }, [_c('div', {
    staticClass: "col-12 mb-3"
  }, [_c('label', {
    attrs: {
      "for": "recipient-name"
    }
  }, [_vm._v("收件人姓名"), _c('span', {
    staticClass: "text-primary"
  }, [_vm._v("*")])]), _c('input', {
    staticClass: "field__input",
    attrs: {
      "type": "text",
      "id": "recipient-name",
      "placeholder": "請輸入收件人姓名"
    }
  })]), _c('div', {
    staticClass: "col-6 mb-3"
  }, [_c('label', {
    attrs: {
      "for": "recipient-city"
    }
  }, [_vm._v("縣市"), _c('span', {
    staticClass: "text-primary"
  }, [_vm._v("*")])]), _c('select', {
    staticClass: "field__input"
  }, [_c('option', [_vm._v("請選擇")])])]), _c('div', {
    staticClass: "col-6 mb-3"
  }, [_c('label', {
    attrs: {
      "for": "recipient-dist"
    }
  }, [_vm._v("鄉鎮市區"), _c('span', {
    staticClass: "text-primary"
  }, [_vm._v("*")])]), _c('select', {
    staticClass: "field__input"
  }, [_c('option', [_vm._v("請選擇")])])]), _c('div', {
    staticClass: "col-12 mb-3"
  }, [_c('label', {
    attrs: {
      "for": "recipient-addr"
    }
  }, [_vm._v("地址"), _c('span', {
    staticClass: "text-primary"
  }, [_vm._v("*")])]), _c('input', {
    staticClass: "field__input",
    attrs: {
      "type": "text",
      "id": "recipient-addr",
      "placeholder": "請輸入地址"
    }
  })]), _c('div', {
    staticClass: "col-12"
  }, [_c('label', {
    attrs: {
      "for": "recipient-phone"
    }
  }, [_vm._v("收件人電話"), _c('span', {
    staticClass: "text-primary"
  }, [_vm._v("*")])]), _c('input', {
    staticClass: "field__input",
    attrs: {
      "type": "text",
      "id": "recipient-phone",
      "placeholder": "請輸入收件人電話"
    }
  })])])])], 1)], 1)]), _c('div', {
    staticClass: "card mt-2 shadow-sm"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between align-items-center"
  }, [_vm._v(" 付款方式 ")]), _c('div', {
    staticClass: "p-3"
  }, [_c('b-form-group', [_c('b-form-radio', {
    staticClass: "py-2",
    attrs: {
      "value": "1"
    },
    model: {
      value: _vm.paymentType,
      callback: function callback($$v) {
        _vm.paymentType = $$v;
      },
      expression: "paymentType"
    }
  }, [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("信用卡一次付清")]), _c('div', {
    staticClass: "py-3 row"
  }, [_c('div', {
    staticClass: "col-12 mb-3"
  }, [_c('label', {
    attrs: {
      "for": "card-number"
    }
  }, [_vm._v("信用卡卡號"), _c('span', {
    staticClass: "text-primary"
  }, [_vm._v("*")])]), _c('input', {
    staticClass: "field__input",
    attrs: {
      "type": "text",
      "id": "card-number",
      "placeholder": "請輸入信用卡卡號"
    }
  })]), _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "card-expired-month"
    }
  }, [_vm._v("有效月"), _c('span', {
    staticClass: "text-primary"
  }, [_vm._v("*")])]), _c('select', {
    staticClass: "field__input"
  }, [_c('option', [_vm._v("月")])])]), _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "card-expired-year"
    }
  }, [_vm._v("有效年"), _c('span', {
    staticClass: "text-primary"
  }, [_vm._v("*")])]), _c('select', {
    staticClass: "field__input"
  }, [_c('option', [_vm._v("年")])])]), _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "card-cvv"
    }
  }, [_vm._v("驗證碼"), _c('span', {
    staticClass: "text-primary"
  }, [_vm._v("*")])]), _c('input', {
    staticClass: "field__input",
    attrs: {
      "type": "text",
      "id": "card-cvv",
      "placeholder": "驗證碼"
    }
  })]), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "",
      "id": "card-remember"
    }
  }), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "card-remember"
    }
  }, [_vm._v(" 我同意紀錄本次付款資訊 ")])])])])]), _c('b-form-radio', {
    staticClass: "py-2 font-weight-bold",
    attrs: {
      "value": "2"
    },
    model: {
      value: _vm.paymentType,
      callback: function callback($$v) {
        _vm.paymentType = $$v;
      },
      expression: "paymentType"
    }
  }, [_vm._v("信用卡分期付款")]), _c('b-form-radio', {
    staticClass: "py-2 font-weight-bold",
    attrs: {
      "value": "3"
    },
    model: {
      value: _vm.paymentType,
      callback: function callback($$v) {
        _vm.paymentType = $$v;
      },
      expression: "paymentType"
    }
  }, [_vm._v("ATM轉帳")])], 1)], 1)]), _c('div', {
    staticClass: "card mt-2 shadow-sm"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between align-items-center"
  }, [_vm._v(" 發票資訊 ")]), _c('div', {
    staticClass: "p-3"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('nav', {
    staticClass: "nav justify-content-around"
  }, [_c('a', {
    staticClass: "flex-fill text-sm-center nav-link text-center",
    class: _vm.invoiceTab == 1 && 'active',
    attrs: {
      "role": "button"
    },
    on: {
      "click": function click($event) {
        _vm.invoiceTab = 1;
      }
    }
  }, [_vm._v("個人")]), _c('a', {
    staticClass: "flex-fill text-sm-center nav-link text-center",
    class: _vm.invoiceTab == 2 && 'active',
    attrs: {
      "role": "button"
    },
    on: {
      "click": function click($event) {
        _vm.invoiceTab = 2;
      }
    }
  }, [_vm._v("公司")])]), _c('div', {
    staticClass: "p-3"
  }, [_vm.invoiceTab == 1 ? _c('div', [_c('b-form-group', [_c('b-form-radio', {
    staticClass: "py-2",
    attrs: {
      "value": "1"
    },
    model: {
      value: _vm.invoiceCarrier,
      callback: function callback($$v) {
        _vm.invoiceCarrier = $$v;
      },
      expression: "invoiceCarrier"
    }
  }, [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("手機條碼載具")]), _c('div', {
    staticClass: "py-3 row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    staticClass: "field__input",
    attrs: {
      "type": "text",
      "placeholder": "請輸入/後大寫7個英數字"
    }
  })]), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "",
      "id": "invoice-remember"
    }
  }), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "invoice-remember"
    }
  }, [_vm._v(" 我同意紀錄本次付款資訊 ")])])])])]), _c('b-form-radio', {
    staticClass: "py-2 font-weight-bold",
    attrs: {
      "value": "2"
    },
    model: {
      value: _vm.invoiceCarrier,
      callback: function callback($$v) {
        _vm.invoiceCarrier = $$v;
      },
      expression: "invoiceCarrier"
    }
  }, [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("自然人憑證條碼載具")]), _c('div', {
    staticClass: "py-3 row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    staticClass: "field__input",
    attrs: {
      "type": "text",
      "placeholder": "請輸入自然人憑證"
    }
  })]), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "",
      "id": "invoice-remember"
    }
  }), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "invoice-remember"
    }
  }, [_vm._v(" 我同意紀錄本次付款資訊 ")])])])])])], 1)], 1) : _vm.invoiceTab == 2 ? _c('div', [_c('b-form-group', [_c('b-form-radio', {
    staticClass: "py-2",
    attrs: {
      "value": "3"
    },
    model: {
      value: _vm.invoiceCarrier,
      callback: function callback($$v) {
        _vm.invoiceCarrier = $$v;
      },
      expression: "invoiceCarrier"
    }
  }, [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("公司發票")]), _c('div', {
    staticClass: "py-3 row"
  }, [_c('div', {
    staticClass: "col-12 mb-3"
  }, [_c('input', {
    staticClass: "field__input",
    attrs: {
      "type": "text",
      "placeholder": "請輸入統一編號"
    }
  })]), _c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    staticClass: "field__input",
    attrs: {
      "type": "text",
      "placeholder": "請輸入抬頭"
    }
  })]), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "",
      "id": "invoice-remember"
    }
  }), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "invoice-remember"
    }
  }, [_vm._v(" 我同意紀錄本次付款資訊 ")])])])])])], 1)], 1) : _vm._e()])])])]), _c('div', {
    staticClass: "sticky-bottom"
  }, [_vm._m(0), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center p-3"
  }, [_vm._m(1), _c('div', {
    staticClass: "flex-fill pl-3"
  }, [_c('router-link', {
    staticClass: "btn w-100 btn-primary btn-lg",
    attrs: {
      "to": {
        name: 'LiffShopFinished'
      }
    }
  }, [_vm._v(" 確認結帳 ")])], 1)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "border-bottom small px-3 py-2 border-top"
  }, [_vm._v(" 結帳即同意及閱讀"), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("隱私權條款")]), _vm._v("與"), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("購買須知")]), _vm._v("。 ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("總金額")]), _c('div', {
    staticClass: "price"
  }, [_vm._v("$ 3,560")])]);
}]

export { render, staticRenderFns }